import Vue from 'vue';
export default Vue.extend({
    name: 'singleConvertConfirmSpotPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    }
});
